module.exports = __webpack_public_path__ + "static/media/x-close-dialog.a393d266.svg";